import request from "@/utils/request";
import { getAuthorizationHeader } from ".";

export async function create(reservation) {
  const response = await request.post(
    "/reservations",
    reservation,
    getAuthorizationHeader()
  );
  return response.data.data;
}

export async function linkOrder(id, orderId) {
  await request.patch(`/reservations/${id}/link-order`, { orderId });
}

export async function getById(id) {
  const response = await request.get(`/reservations/${id}`);
  return response.data.data;
}

export async function listMine({ page, size }) {
  const response = await request.get(
    `/reservations/me?page=${page}&size=${size}`,
    getAuthorizationHeader()
  );
  return response.data.data;
}

export async function getTodayReservationByPhone(phone) {
  const response = await request.get(`/reservations/phone/${phone}`);
  return response.data.data;
}

export async function getReservationRulesByDate(date) {
  return (await request.get(`/settings/reservation-rules/date/${date}`)).data
    .data;
}

export async function getPreOrderLinkByShortCode(shortCode) {
  return (await request.get(`/reservations/pre-order-url/${shortCode}`)).data
    .data;
}
